import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Tag } from "src/db/Order"

export const OrderTagLabel: FC<{ tag: Tag }> = ({ tag }) => {
  const { t } = useTranslation()

  const getTranslatedTagLabel = (label: string, labelKey: string) => {
    return label?.includes(labelKey) ? t(label) : label
  }

  const shortLabel = getTranslatedTagLabel(tag.shortLabel, "tag.label")
  const longLabel = getTranslatedTagLabel(tag.label, "tag.label_long")

  const label =
    tag.shortLabel && tag.label
      ? `${shortLabel} - ${longLabel}`
      : shortLabel || longLabel || ""

  return label
}
